/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/no-explicit-any */
import styles from "../../Styles/dashboard.module.css";
import { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  EmailTemplateModel,
  LineModel,
  NotesModel,
  OrderModel,
} from "../../Utils/Models";
import { getData } from "../../Services/getData";
import { localUrlEnum, urlEnum } from "../../Utils/UrlEnum";
import OrderDataComponents from "./OrderDataComponents";
import { postData } from "../../Services/postData";
import OrderHeader from "./OrderHeader";
import { updateData } from "../../Services/updateData";
import { OrderContext } from "../../Contexts/OrderContext";
import { useMediaQuery } from "@mui/material";
import SendEmailModal from "./SendEmailModal";

export type EditNoteType = {
  index: number;
  note: NotesModel | null;
  filter: Array<string>;
};

export async function addOrUpdateOrder(orderContext: any) {
  const newOrder: OrderModel = Object.assign({}, orderContext.order);
  newOrder.notes = orderContext.order.notes.map((note: NotesModel) => {
    return {
      _id: note._id,
      title: note.title || "",
      text: note.text || "",
      type: note.type || "",
      createdBy: note.createdBy,
      createdAt: note.createdAt,
    };
  });
  newOrder.lines =
    orderContext.order.lines &&
    orderContext.order.lines.filter((line: LineModel) => line.product);
  newOrder.orderedBy = orderContext.order.orderedBy || null;
  // newOrder.total = orderContext.order.lines && orderContext.order.lines
  //   .reduce((accumulator: string, line: LineModel) => {
  //     return +accumulator + +line.total;
  //   }, 0)
  //   .toFixed(2);
  newOrder.total = 0;
  // newOrder.totalWithoutVat = orderContext.order.lines && orderContext.order.lines
  //   .reduce((accumulator: string, line: LineModel) => {
  //     return +accumulator + +line.totalWithoutVat;
  //   }, 0)
  //   .toFixed(2);
  newOrder.totalWithoutVat = 0;
  newOrder.totalRemaining = newOrder.total - newOrder.totalCharged;

  if (newOrder.status && newOrder.status.isFinalStatus) {
    newOrder.isFinished = true;
    newOrder.isClosed = true;
    newOrder.lines.map(async (line) => {
      if (line.product?.inventory?.inventory?.hasRepairItems) {
        await updateData(`${urlEnum.products}/singleProduct`, {
          productId: line.product._id,
          inventoryId: line.product.inventory.inventory._id,
          quantity: Number(line.quantity),
        });
      }
    });
  }
  if (orderContext.order?._id) {
    const res = await updateData(
      `${urlEnum.orders}/${orderContext.order._id}`,
      newOrder,
    );
    if (res) {
      orderContext.setOrder(res.data.result);
    }
  } else {
    const res = await postData(urlEnum.orders, newOrder);
    if (res) {
      // navigate(`${localUrlEnum.orders}/${res.data.result._id}`);
      window.location.href = `${localUrlEnum.orders}/${res.data.result._id}`;
    }
  }
}

export default function ServiceOrder() {
  const location = useLocation();
  const phoneStyle = useMediaQuery("(max-width: 800px)");
  const [notesBackup, setNotesBackup] = useState<Array<NotesModel>>([]);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [openEmailModal, setOpenEmailModal] = useState(false);
  const [emailTemplate, setEmailTemplate] = useState<EmailTemplateModel | null>(
    null,
  );
  const orderContext = useContext(OrderContext);
  const open = Boolean(anchorEl);
  /**
   *
   */
  useEffect(() => {
    const id: string = location.pathname.split("/").pop() || "";
    if (id === "newOrder") orderContext.setOrder(new OrderModel());
    else {
      getOrder(id);
      getEmailsAndSaveThem(id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  useEffect(() => {
    getEmailTemplate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderContext.order.oldStatus]);

  /////////////////////////// SETTINGS MENU ///////////////////////////

  /**
   *
   * @param event
   */
  function handleClick(event: React.MouseEvent<HTMLElement>) {
    setAnchorEl(event.currentTarget);
  }
  /**
   *
   */
  function handleCloseMenu() {
    setAnchorEl(null);
  }
  /////////////////////////// END SETTINGS MENU ///////////////////////////

  /////////////////////////// CHANGE ORDER PRIORITY ///////////////////////////

  /**
   *
   * @param priority
   */
  function handleChangePriority(priority: string) {
    const newOrder = Object.assign({}, orderContext.order);
    newOrder.priority = priority;
    orderContext.setOrder(newOrder);
    setAnchorEl(null);
    //addOrUpdateOrder(orderContext);
  }
  /////////////////////////// END CHANGE ORDER PRIORITY ///////////////////////////

  /////////////////////////// DUPLICATE ORDER ///////////////////////////

  /**
   *
   */
  async function handleDuplicateOrder() {
    //duplicateOrder
    if (orderContext.order && orderContext.order._id)
      await postData(
        `${urlEnum.orders}/duplicateOrder/${orderContext.order._id}`,
      ).then((res) => {
        if (
          res &&
          res.data &&
          (res.data.status === 200 || res.data.status === 201)
        ) {
          window.open(
            `${localUrlEnum.orders}/${res.data.result._id}`,
            "_blank",
          );
        }
      });
  }
  /////////////////////////// END DUPLICATE ORDER ///////////////////////////

  /////////////////////////// CLOSE ORDER //////////////////////////
  /**
   *
   */
  async function handleCloseOrder() {
    const res = await postData(
      `${urlEnum.orders}/close/${orderContext.order._id}`,
    );
    if (res && res.data && res.data.result) {
      orderContext.setOrder(res.data.result);
    }
  }
  /////////////////////////// END CLOSE ORDER //////////////////////////

  /////////////////////////// GET ORDER ///////////////////////////
  /**
   *
   * @param id
   */
  function getOrder(id: string) {
    getData(`${urlEnum.orders}/${id}`)
      .then((res) => {
        if (res) {
          const resOrder = res.data.result;
          if (resOrder.lines && resOrder.lines.length === 0)
            resOrder.lines = [new LineModel()];
          if (resOrder.notes && resOrder.notes.length !== 0)
            resOrder.notes = resOrder.notes.reverse();
          setNotesBackup(resOrder.notes);
          orderContext.setOrder(res.data.result);
        }
      })
      .catch((err) => {
        //
      });
  }

  /**
   *
   * @returns
   */
  async function getEmailTemplate() {
    const statusName = orderContext.order.oldStatus
      ? orderContext.order.oldStatus.name
      : null;
    if (!statusName) return;
    const res = await getData(`${urlEnum.emailTemplates}/status/${statusName}`);
    if (res && res.data && res.data.result) {
      setEmailTemplate(res.data.result);
    }
  }
  /**
   *
   * @param id
   */
  function getEmailsAndSaveThem(id: string) {
    getData(`${urlEnum.orders}/getEmails/${id}`);
  }

  /////////////////////////// END GET ORDER ///////////////////////////

  return (
    <div
      id="parentOrder"
      className={
        phoneStyle ? styles.mainContainerOrderMobile : styles.mainContainerOrder
      }
    >
      <OrderHeader
        anchorEl={anchorEl}
        open={open}
        handleChangeOpenEmailModal={(newOpenEmailModal: boolean) =>
          setOpenEmailModal(newOpenEmailModal)
        }
        handleCloseMenu={handleCloseMenu}
        handleClick={handleClick}
        handleChangePriority={handleChangePriority}
        handleDuplicateOrder={handleDuplicateOrder}
        handleCloseOrder={handleCloseOrder}
      />
      <OrderDataComponents notesBackup={notesBackup} />
      <SendEmailModal
        open={openEmailModal}
        editEmailTemplate={emailTemplate}
        onClose={() => setOpenEmailModal(false)}
        addOrUpdateEmailTemplate={(emailTemplate: EmailTemplateModel | null) =>
          null
        }
      />
    </div>
  );
}
